import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import Base from '../base.entity';

@Entity('series_sets')
export default class SeriesSet extends Base {
	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	series_id: number;

	@Column('int')
	created_by: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	static rules() {
		return {
			id: Joi.number().integer(),
			series_id: Joi.number().integer(),
			created_by: Joi.number().integer(),
			date_created: Joi.date().allow(null),
		};
	}

	toJSON() {
		return {
			id: this.id,
			series_id: this.series_id,
			created_by: this.created_by,
			date_created: this.date_created,
		};
	}

	assign(props?: GenPartial<SeriesSet>) {
		super.assign(props);

		if (props) {
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<SeriesSet>) {
		super(props);
	}
}
